import { getOuterRange } from '../Table'
import store from '@/store'

export default {
  getUpdatedLogLocations: function() {
    let updates = {}
    this.getCurrentData().forEach(datum => {
      if (datum.data.logLocation && datum.data.logLocation != datum.data.location) {
        updates[datum.data.logLocation] = datum.data.location
        datum.data.logLocation = datum.data.location
      }
    })
    return updates
  },
  getAdjustedLogLocations: function(rowIndex) {
    let startIndex = rowIndex * this.getMaxWidth()
    let endIndex = (rowIndex + 1) * this.getMaxWidth()

    let { inner } = getOuterRange(this.getCurrentData(), startIndex, endIndex)
    let removedLocations = inner.reduce((accumulator, current) => {
      let location = current.data.logLocation
      if (location) return accumulator.concat(location)
      else return accumulator
    }, [])

    return removedLocations
  },
  removeLogs: async function(locations) {
    let removedLogs = await store.dispatch('reviewingestionresults/removeLogs', locations)
    removedLogs.forEach(log => {
      this.triggerUILogUpdates(log.location)
    })

    return removedLogs
  },
  updateLogs: async function(locations) {
    await store.dispatch('reviewingestionresults/updateLogLocations', locations)
    for (let [oldLocation, newLocation] of Object.entries(locations)) {
      this.triggerUILogUpdates(oldLocation)
      this.triggerUILogUpdates(newLocation)
    }
  },
  addLogs: async function(logs) {
    if (!logs) return
    await store.dispatch('reviewingestionresults/addLogs', logs)
    logs.forEach(log => {
      this.triggerUILogUpdates(log.location)
    })
  },
}